import { useEffect, useState } from 'react';
import { timeToClockFormat } from '../utils/time';

export default function Clock() {
  const [currentTime, setCurrentTime] = useState(timeToClockFormat(Date.now()));

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setCurrentTime(timeToClockFormat(Date.now()));
    }, 1000);
    return () => {
      window.clearInterval(intervalId);
    };
  });

  return <time role="timer">{currentTime}</time>;
}
